module.exports = __webpack_public_path__ + "static/media/CircleCross.c0738c17.svg";